import {fetchGet, generateEndpoint} from "../../../utils/request";

type GetCaseByUserLineIdParams = {
  token: string;
  id: string | number;
}

export const getCaseByUserLineId = async({
  token,
  id
}: GetCaseByUserLineIdParams) => {
  const url = `${generateEndpoint('getCaseByIdUser')}?id=${id}`
  return fetchGet(url, token)
}
